import { IntegrationsGenieDesktopAdaptor } from '@/integrations/desktop/adaptors/genie/integrations-genie-desktop-adaptor';
import type { IntegrationDesktopBaseAdaptor } from '@/integrations/desktop/mixins/IntegrationDesktopBaseAdaptor';
import { EHRProvider } from '@heidi/schema/ml-scribe';

export const IntegrationDesktopClientMap: Partial<
  Record<EHRProvider, IntegrationDesktopBaseAdaptor>
> = {
  [EHRProvider.Genie]: IntegrationsGenieDesktopAdaptor,
};
